import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap, switchMapTo } from "rxjs/operators";
import { selectAllEventInfo, selectExpiredThemedEventQuest, selectIsEventExpired, selectIsEventRunning, } from "../../../selectors/selectEventInfo";
import { utilTick } from "../../../utils/utilTick";
import { TypeActionApp } from "../../app/actionApp";
import { actionEventInfoRemoveEvent, actionEventInfoRequest, actionEventInfoStartEvent, } from "../../info/event/actionEventInfo";
import { State } from "../../info/event/reducerEventInfo";
import { actionQuestRemoveQuest } from "../../info/quest/actionQuestInfo";
import { actionThemedEventLoadBuilding } from "../../themed-events/actionThemedEvent";
import { mapThemedEventInfo } from "../../themed-events/mapThemedEventInfo";
export var epicTimeEvents = function (action$, state$) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(utilTick.second$), switchMap(function () {
        var state = state$.value;
        var actions = [];
        selectAllEventInfo(state).forEach(function (event) {
            var isExpired = selectIsEventExpired(event.proto);
            if (isExpired) {
                var typeId = event.proto.typeId;
                var themedEvent = typeId ? mapThemedEventInfo.get(typeId) : undefined;
                if (themedEvent) {
                    var quest = selectExpiredThemedEventQuest(state);
                    actions.push(actionQuestRemoveQuest(quest), actionThemedEventLoadBuilding(), actionEventInfoRequest());
                }
                actions.push(actionEventInfoRemoveEvent(event.proto.eventId));
            }
            else if (selectIsEventRunning(event.proto) &&
                event.proto.state === State.PENDING) {
                actions.push(actionEventInfoStartEvent(event.proto.eventId));
            }
        });
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimeEvents.ts
// module id = 2435
// module chunks = 3